import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {SupportComponent} from './components/support.component';
import {PinDialogComponent} from './components/pinDialog/pinDialog.component';
import {SupportDetailComponent} from './components/supportDetail/supportDetail.component';
import {UsingTheCourseSupportArticleComponent} from './components/articles/usingTheCourse.component';
import {SettingsSupportArticleComponent} from './components/articles/settings.component';
import {AccessibilitySupportArticleComponent} from './components/articles/accessibility.component';
import {TrialSupportArticleComponent} from './components/articles/trial.component';
import {AccountSetupSupportArticleComponent} from './components/articles/accountSetup.component';
import {GettingStartedSupportArticleComponent} from './components/articles/gettingStarted.component';
import {ClassesSupportArticleComponent} from './components/articles/classes.component';
import {StudentsSupportArticleComponent} from './components/articles/students.component';
import {InstructorsSupportArticleComponent} from './components/articles/instructors.component';
import {ExercisesSupportArticleComponent} from './components/articles/exercises.component';
import {AddClassSupportArticleComponent} from './components/articles/addClass.component';
import {EditClassSupportArticleComponent} from './components/articles/editClass.component';
import {ArchiveClassSupportArticleComponent} from './components/articles/archiveClass.component';
import {EnrollStudentsSupportArticleComponent} from './components/articles/enrollStudents.component';
import {LicensesSupportArticleComponent} from './components/articles/licenses.component';
import {EditStudentSupportArticleComponent} from './components/articles/editStudent.component';
import {ResetStudentPasswordSupportArticleComponent} from './components/articles/resetStudentPassword.component';
import {DeleteStudentSupportArticleComponent} from './components/articles/deleteStudent.component';
import {StudentProgressSupportArticleComponent} from './components/articles/studentProgress.component';
import {RestoreStudentSupportArticleComponent} from './components/articles/restoreStudent.component';
import {EnrollOrderSupportArticleComponent} from './components/articles/enrollOrder.component';
import {AdvanceOrderSupportArticleComponent} from './components/articles/advanceOrder.component';
import {AssignLicensesSupportArticleComponent} from './components/articles/assignLicenses.component';
import {StudentOrderSupportArticleComponent} from './components/articles/studentOrder.component';
import {
    DifferenceInstructorAdministratorSupportArticleComponent
} from './components/articles/differenceInstructorAdministrator.component';
import {AddInstructorSupportArticleComponent} from './components/articles/addInstructor.component';
import {EditInstructorSupportArticleComponent} from './components/articles/editInstructor.component';
import {ResetInstructorPasswordSupportArticleComponent} from './components/articles/resetInstructorPassword.component';
import {DeleteInstructorSupportArticleComponent} from './components/articles/deleteInstructor.component';
import {RestoreInstructorSupportArticleComponent} from './components/articles/restoreInstructor.component';
import {InstructorCourseAccessSupportArticleComponent} from './components/articles/instructorCourseAccess.component';
import {AddExerciseSupportArticleComponent} from './components/articles/addExercise.component';
import {ExerciseAccessSupportArticleComponent} from './components/articles/exerciseAccess.component';
import {EditExerciseSupportArticleComponent} from './components/articles/editExercise.component';
import {DeleteExerciseSupportArticleComponent} from './components/articles/deleteExercise.component';
import {ResourcesSupportArticleComponent} from './components/articles/resources.component';
import {LoginCredentialsSupportArticleComponent} from './components/articles/loginCredentials.component';
import {AssignInstructorSupportArticleComponent} from './components/articles/assignInstructor.component';
import {SupportRoutingModule} from './support-routing.module';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {SharedModule} from '../shared/shared.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {SupportModalsComponent} from './components/modals/modals.component';
import {MatRippleModule} from '@angular/material/core';


@NgModule({
    declarations: [
        // Components
        SupportComponent,
        PinDialogComponent,
        SupportDetailComponent,
        UsingTheCourseSupportArticleComponent,
        SettingsSupportArticleComponent,
        AccessibilitySupportArticleComponent,
        TrialSupportArticleComponent,
        AccountSetupSupportArticleComponent,
        GettingStartedSupportArticleComponent,
        ClassesSupportArticleComponent,
        StudentsSupportArticleComponent,
        InstructorsSupportArticleComponent,
        ExercisesSupportArticleComponent,
        AddClassSupportArticleComponent,
        EditClassSupportArticleComponent,
        ArchiveClassSupportArticleComponent,
        EnrollStudentsSupportArticleComponent,
        LicensesSupportArticleComponent,
        EditStudentSupportArticleComponent,
        ResetStudentPasswordSupportArticleComponent,
        DeleteStudentSupportArticleComponent,
        StudentProgressSupportArticleComponent,
        RestoreStudentSupportArticleComponent,
        EnrollOrderSupportArticleComponent,
        AdvanceOrderSupportArticleComponent,
        AssignLicensesSupportArticleComponent,
        StudentOrderSupportArticleComponent,
        DifferenceInstructorAdministratorSupportArticleComponent,
        AddInstructorSupportArticleComponent,
        EditInstructorSupportArticleComponent,
        ResetInstructorPasswordSupportArticleComponent,
        DeleteInstructorSupportArticleComponent,
        RestoreInstructorSupportArticleComponent,
        InstructorCourseAccessSupportArticleComponent,
        AddExerciseSupportArticleComponent,
        ExerciseAccessSupportArticleComponent,
        EditExerciseSupportArticleComponent,
        DeleteExerciseSupportArticleComponent,
        ResourcesSupportArticleComponent,
        LoginCredentialsSupportArticleComponent,
        AssignInstructorSupportArticleComponent,
        SupportModalsComponent
    ],
    imports: [
        CommonModule,
        SupportRoutingModule,
        SharedModule,
        NgOptimizedImage,

        // Material modules
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatExpansionModule,
        MatSnackBarModule,
        MatRippleModule
    ],
    providers: [
        // Services

    ]
})
export class SupportModule {
}
